import { type InsuranceCorporateIdentity } from "../types";

export function BKKPfaffLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_30_1249)">
        <path d="M506 6H6V506H506V6Z" fill="#007BC2" />
        <path
          d="M69.7 403.6H77C80.2 403.6 82.5 405.5 82.5 408.3C82.5 412 80.1 413.4 76.5 413.4H69.5999V403.6H69.7ZM69.7 433.4V422.9H78.5C81.5 423.1 83.4 425.7 83.4 428.4C83.4 431.5 80.9 433.5 77.5 433.5H69.7V433.4ZM79.0999 442.8C79.4999 442.8 97.5999 443.8 97.5999 429.6C97.5999 422.7 92.3 418.6 85.9 417.7V417.5C91.4 416.5 96.4 412.9 96.4 406.8C96.4 398.2 88.7 394.1 79.5 394.1H56.2V442.8H79.0999Z"
          fill="white"
        />
        <path
          d="M119.9 415.5H119.7V394.1H106.2V442.8H119.7V416.9H119.9L135.9 442.8H152.6L134.5 415.5L151.3 394.1H135.3L119.9 415.5Z"
          fill="white"
        />
        <path
          d="M173 415.5H172.9V394.1H159.4V442.8H172.9V416.9H173L189.1 442.8H205.8L187.6 415.5L204.4 394.1H188.5L173 415.5Z"
          fill="white"
        />
        <path
          d="M248.7 416V403.6H255.6C260.9 403.8 263.2 406.2 263.2 409.8C263.2 413.4 261 415.8 255.6 416H248.7ZM248.7 442.8V425.4H257.6C269.5 425.4 277.4 421.6 277.4 409.7C277.4 397.9 269.6 394.1 257.6 394.1H235.2V442.8H248.7Z"
          fill="white"
        />
        <path
          d="M297.9 424.3H317.4V414.9H297.9V403.6H318.9V394.1H284.4V442.8H297.9V424.3Z"
          fill="white"
        />
        <path
          d="M338.6 423.9L345.2 403.7H345.4L351.6 423.9H338.6ZM332 442.8L335.2 433.3H355L358.2 442.8H373.5L354.3 394.1H337.8L318.6 442.8H332Z"
          fill="white"
        />
        <path
          d="M393 424.3H412.5V414.9H393V403.6H414V394.1H379.5V442.8H393V424.3Z"
          fill="white"
        />
        <path
          d="M434.8 424.3H454.3V414.9H434.8V403.6H455.8V394.1H421.3V442.8H434.8V424.3Z"
          fill="white"
        />
        <path
          d="M213.2 157.1H299.2L298.9 156.8L211.3 69.2H125.3L213.2 157.1Z"
          fill="#FFD500"
        />
        <path d="M299.4 244.4H212.9V331H299.4V244.4Z" fill="#FFD500" />
        <mask
          id="mask0_30_1249"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="125"
          y="69"
          width="262"
          height="262"
        >
          <path d="M386.7 69.2H125.3V330.9H386.7V69.2Z" fill="white" />
        </mask>
        <g mask="url(#mask0_30_1249)">
          <path
            d="M279.8 184.2C279.8 180.5 282.9 177.4 286.6 177.4C290.3 177.4 293.4 180.4 293.4 184.2C293.4 188 290.4 191 286.6 191C282.9 191 279.8 188 279.8 184.2ZM286.6 192.5C291.1 192.5 294.8 188.8 294.8 184.3C294.8 179.8 291.1 176.1 286.6 176.1C282.1 176.1 278.4 179.8 278.4 184.3C278.4 188.8 282.1 192.5 286.6 192.5Z"
            fill="white"
          />
        </g>
        <mask
          id="mask1_30_1249"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="125"
          y="69"
          width="262"
          height="262"
        >
          <path d="M386.7 69.2H125.3V330.9H386.7V69.2Z" fill="white" />
        </mask>
        <g mask="url(#mask1_30_1249)">
          <path
            d="M284.4 183.7V181H286.8C287.8 181 288.8 181.2 288.8 182.4C288.8 184 287.1 183.8 285.9 183.8H284.4V183.7ZM284.4 184.7H286.2L288.6 188.5H289.8L287.2 184.7C288.7 184.6 289.9 183.9 289.9 182.3C289.9 180.8 289.1 179.9 286.9 179.9H283.2V188.5H284.3V184.7H284.4Z"
            fill="white"
          />
        </g>
        <mask
          id="mask2_30_1249"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="125"
          y="69"
          width="262"
          height="262"
        >
          <path d="M386.7 69.2H125.3V330.9H386.7V69.2Z" fill="white" />
        </mask>
        <g mask="url(#mask2_30_1249)">
          <path
            d="M243 176V198.9L260.2 176.1H276.2L258.1 198.6C263.9 207.7 276.5 225.3 276.5 225.3H259.5C259.5 225.3 243.2 199.9 243.1 199.9V225.1H228.9V176H243Z"
            fill="white"
          />
        </g>
        <mask
          id="mask3_30_1249"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="125"
          y="69"
          width="262"
          height="262"
        >
          <path d="M386.7 69.2H125.3V330.9H386.7V69.2Z" fill="white" />
        </mask>
        <g mask="url(#mask3_30_1249)">
          <path
            d="M190.4 176.1L190.5 198.7C190.5 198.7 201.8 183.5 207.2 176.1H223.1L205.4 198.4L224.1 225.2H207C207 225.2 190.8 199.5 190.5 199.5C190.4 208.6 190.5 225 190.5 225H176L175.9 175.9H190.4V176.1Z"
            fill="white"
          />
        </g>
        <mask
          id="mask4_30_1249"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="125"
          y="69"
          width="262"
          height="262"
        >
          <path d="M386.7 69.2H125.3V330.9H386.7V69.2Z" fill="white" />
        </mask>
        <g mask="url(#mask4_30_1249)">
          <path
            d="M168.2 206.8C166.1 203 162.1 200.3 157.9 200V199.7C159.5 199.2 161.1 198.4 162.6 197.6C166.1 195.1 168.2 191.2 167.2 186.7C166.5 182.5 162.7 178.7 158.7 177.4C150.4 175.2 136.7 176.4 125.3 176.1V225.1H149.1C156.1 225.4 162.7 224.1 167 218.7C169.1 214.9 169.9 211 168.2 206.8ZM139.5 184.8H143.9C148.7 184.7 152.9 185.2 154.3 188.2C155 190.1 154.9 192.8 153.5 194.4C150 198 144.6 196.3 139.5 196.6V184.8ZM155.7 212.4C155 214.1 153.5 215.2 152 216C148.2 216.8 143.5 216.2 139.6 216.4V203.7C144.4 203.9 152.4 202.3 155.3 207C156 208.6 156.2 210.7 155.7 212.4Z"
            fill="white"
          />
        </g>
        <path
          d="M299.2 157.1V244.4L386.7 157V156.2L386.6 69.3999L299.2 157.1Z"
          fill="#FFD500"
        />
      </g>
      <defs>
        <clipPath id="clip0_30_1249">
          <rect
            width="500"
            height="500"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const BKKPfaff: InsuranceCorporateIdentity = {
  id: "bkk-pfaff",
  name: "BKK Pfaff",
  logo: BKKPfaffLogo,
  backgroundColor: "#007BC2",
  textColor: "#FFFFFF",
  wildcard: "bkk pfaff",
  type: "statutory",
};
